'use strict';

import AxiosService from '../AxiosService';

// nice example: https://gist.github.com/paulsturgess/ebfae1d1ac1779f18487d3dee80d1258

const PHOTO_ENDPOINT = "/api/v1/camera"

export default class PhotoService {

    constructor() {
        this.service = new AxiosService();
    }

    savePhoto(formData) {
        return this.service.post(PHOTO_ENDPOINT, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    getPhotoUrls(idAssignment, idAddress) {
        return this.service.get(PHOTO_ENDPOINT + "/" + idAssignment + "/" + idAddress)
    }

    loadPhoto(url) {
        return this.service.get(url)
    }
}

